import { css } from 'aphrodite';
import React from 'react';
import { Button } from '../../components-v2/Button';
import { THEME } from '../../components-v2/Theme/theme';
import { SparklesIcon } from '../svgs/icons/SparklesIcon';
import { XIcon } from '../svgs/icons/XIcon';
import { styleSheet } from './styles';

interface ImagePreviewProps {
	videoElement: HTMLVideoElement;
	onRemove: () => void; // Callback function to handle the removal of the image
	onEdit?: () => void; // Optional callback for AI image editing
	editButtonLabel?: string;
}

export const VideoPreview: React.FC<ImagePreviewProps> = ({
	videoElement,
	onRemove,
	onEdit,
	editButtonLabel = 'Edit Media with AI',
}) => {
	return (
		<div className={css(styleSheet.imageContainer)}>
			<figure className={css(styleSheet.imageWrap)}>
				<video src={videoElement.src} className={css(styleSheet.image)} />
			</figure>
			<section className={css(styleSheet.imageSection)}>
				<div className={css(styleSheet.closeButtonContainer)}>
					<button onClick={onRemove}>
						<XIcon height={14} width={14} color={THEME.colors.icon.gray} />
					</button>
				</div>
				{onEdit && (
					<div className={css(styleSheet.imageActions)}>
						<Button size='sm' variant='secondary' onClick={onEdit}>
							<SparklesIcon />
							{editButtonLabel}
						</Button>
					</div>
				)}
			</section>
		</div>
	);
};
